import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Badge } from "reactstrap"

const PricingConfirmationModal = ({ isOpen, toggle, onConfirm, pricingSummary, loading }) => {
    if (!pricingSummary) return null

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Confirm Pricing Template Creation</ModalHeader>
            <ModalBody>
                <div style={{ padding: "10px 0" }}>
                    <p style={{ fontSize: "16px", marginBottom: "20px" }}>
                        You are about to create the following pricing template:
                    </p>
                    <Row style={{ marginBottom: "15px" }}>
                        <Col xs={4}>
                            <strong>📋 Pricing Type:</strong>
                        </Col>
                        <Col xs={8}>
                            {pricingSummary.pricingType}
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: "15px" }}>
                        <Col xs={4}>
                            <strong>🏢 Branch:</strong>
                        </Col>
                        <Col xs={8}>
                            {pricingSummary.branch}
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: "15px" }}>
                        <Col xs={4}>
                            <strong>💰 Price Details:</strong>
                        </Col>
                        <Col xs={8}>
                            <div>Default: <strong>{pricingSummary.price}</strong></div>
                            <div style={{ fontSize: "14px", color: "#666" }}>
                                Range: {pricingSummary.priceRange}
                            </div>
                        </Col>
                    </Row>
                    {pricingSummary.title && (
                        <Row style={{ marginBottom: "15px" }}>
                            <Col xs={4}>
                                <strong>📝 Title:</strong>
                            </Col>
                            <Col xs={8}>
                                {pricingSummary.title}
                            </Col>
                        </Row>
                    )}
                    <Row style={{ marginBottom: "15px" }}>
                        <Col xs={4}>
                            <strong>🚗 Car Filters:</strong>
                        </Col>
                        <Col xs={8}>
                            {pricingSummary.carModels.length > 0 && (
                                <div>
                                    {pricingSummary.carModels.length === 1 ? (
                                        <span> {pricingSummary.carModels[0]}</span>
                                    ) : (
                                        <>
                                            <strong>✓ Models:</strong>
                                            <ul style={{ marginTop: "5px", marginBottom: "5px", paddingLeft: "20px" }}>
                                                {pricingSummary.carModels.map((model, index) => (
                                                    <li key={index}>{model}</li>
                                                ))}
                                            </ul>
                                        </>
                                    )}
                                </div>
                            )}
                            {pricingSummary.yearRange && (
                                <div>✓ Year: {pricingSummary.yearRange}</div>
                            )}
                            {pricingSummary.mileageRange && (
                                <div>✓ Mileage: {pricingSummary.mileageRange}</div>
                            )}
                            {!pricingSummary.carModels.length && !pricingSummary.yearRange && !pricingSummary.mileageRange && (
                                <div style={{ color: "#999" }}>No specific filters (applies to all matching cars)</div>
                            )}
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: "15px" }}>
                        <Col xs={4}>
                            <strong>⚙️ Settings:</strong>
                        </Col>
                        <Col xs={8}>
                            <div>
                                Visible to Customers: {" "}
                                <Badge color={pricingSummary.visibleToCustomers ? "success" : "danger"}>
                                    {pricingSummary.visibleToCustomers ? "Yes" : "No"}
                                </Badge>
                            </div>
                            <div style={{ marginTop: "5px" }}>
                                Default Pricing: {" "}
                                <Badge color={pricingSummary.isDefault ? "success" : "danger"}>
                                    {pricingSummary.isDefault ? "Yes" : "No"}
                                </Badge>
                            </div>
                        </Col>
                    </Row>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle} disabled={loading}>
                    Go Back
                </Button>
                <Button color="primary" onClick={onConfirm} disabled={loading}>
                    {loading ? "Creating..." : "Confirm & Create"}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default PricingConfirmationModal
